import type { SpreadTemplate } from "../types";
import { BASE_SPREAD_TEMPLATES } from "./base";

// English comment: A4 landscape spread templates (start from base; adjust manually later)
export const SPREADS_A4_LANDSCAPE: SpreadTemplate[] = BASE_SPREAD_TEMPLATES.map((b) => ({
  id: `a4l_${b.idSuffix}`,
  name: b.name,
  format_group: "a4_landscape",
  unitKind: "spread",
  blocks: b.blocks
}));
